import { format, isToday, isYesterday } from 'date-fns'
import React, { ReactElement } from 'react'

import { LogUnfinishedMetadata } from '@/types/logs'
import { Tooltip } from '@/ui/Tooltip'
import { useModal } from '@/components/Modal'
import { ModalTypes } from '@/components/Modal/registry'
import { Role } from '@/types/auth'

import styles from './FlagTooltip.module.scss'

const formatFlagDate = (date: string): string => {
    if (isToday(date)) return `${format(date, 'HH:mm')} today`
    if (isYesterday(date)) return `${format(date, 'HH:mm')} yesterday`
    return format(date, 'HH:mm dd/MM/yyyy')
}

interface Props {
    logId: string
    metadata: LogUnfinishedMetadata | null
    role: Role | null
    children: ReactElement
}

export const FlagTooltip = ({ logId, metadata, role, children }: Props) => {
    const { openModal } = useModal()

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        if (role === Role.PerformanceManager && metadata?.flagState === 'Unfinished') {
            openModal(ModalTypes.markAsDoneModal, { logId })
        } else if (role === Role.MileageClerk) {
            if (metadata?.flag) {
                openModal(ModalTypes.editFlagModal, { logId, metadata })
            } else {
                openModal(ModalTypes.flagLogUnfinishedModal, { logId, metadata })
            }
        }
    }

    const button = (
        <button data-action type="button" onClick={handleClick} className={styles.trigger}>
            {children}
        </button>
    )

    if (!metadata?.flag) return button

    const tooltipContent = (
        <div className={styles.tooltip}>
            <span className={styles.title}>Mileage Clerk Comment</span>
            <div className={styles.body}>
                <p className={styles.comment}>{metadata.comment}</p>
                <div className={styles.footer}>
                    <span className={styles.author}>{metadata.author}</span>
                    <span className={styles.time}>{formatFlagDate(metadata.createdAt)}</span>
                </div>
            </div>
        </div>
    )

    return (
        <button data-action type="button" onClick={handleClick} className={styles.trigger}>
            <Tooltip tooltip={tooltipContent} placement="bottom" trigger="hover" className={styles.container}>
                {children}
            </Tooltip>
        </button>
    )
}
